export default "__VITE_ASSET__475e091e__"